import React, { useState, useEffect } from "react";
import Button from "../../components/common/button/Button";
import Error from "../../components/common/error/Error";
import Backbutton from "../../components/common/backbutton/Backbutton";
import { useSelector } from "react-redux";
import { useVerifyOTPInstance } from "../../utils/userInstance/useVerifyInstance";
import { useResetPasswordOTPVerficationInstance } from "../../utils/userInstance/useResetPasswordOtpverficationInstance";
import { useSendVerificationInstance } from "../../utils/userInstance/useresendverificationEmailInstance";
import OTPInput from "react-otp-input";

const Verification = () => {
  const { UserEmail, isResetVerify } = useSelector(state => state.user);
  const { verifyOTP } = useVerifyOTPInstance({});
  const { resendEmail } = useSendVerificationInstance({});
  const { forgetPasswordOTPVerfication } = useResetPasswordOTPVerficationInstance({});
  const { isUsermanagementLoader } = useSelector(state => state.loader);

  const [otp, setOtp] = useState("");
  const [isValid, setIsValid] = useState(true);

  const handleChange = (value) => {
    setOtp(value);
  };

  const handleSubmit = () => {
    if (otp.length === 6 && /^\d{6}$/.test(otp)) {
      setIsValid(true);
      if (!isResetVerify) {
        verifyOTP({ email: UserEmail, otp });
      } else {
        forgetPasswordOTPVerfication({ email: UserEmail, otp });
      }
    } else {
      setIsValid(false);
    }
  };

  const [timer, setTimer] = useState(60);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);


  const handleResend = () => {
    resendEmail({ email: UserEmail });
    setOtp("");
    setTimer(60); // Reset the countdown
  };


  return (
    <div className="bg-grey-200 w-full h-full lg:w-2/4 flex flex-col justify-center items-center p-5" style={{margin:'auto'}}>
      <div className="w-full min-w-[200px] xs:max-w-[320px] sm:max-w-[420px]">
        <div>
          <p className="text-2xl font-bold text-center lg:text-start">Verify your email</p>
          <p className="text-sm font-medium mt-2 text-center lg:text-start text-gray-500">
            We sent a confirmation code to <span className="text-primary">{UserEmail}</span><br />
            Please enter it below to confirm your email address.<br />
            <span className="text-primary">The OTP will expire in 15 minutes.</span>
          </p>
        </div>


        <div className="mt-5 flex justify-center">
          <OTPInput
            value={otp}
            onChange={handleChange}
            renderInput={(props) => <input {...props} />}
            numInputs={6}
            isInputNum
            shouldAutoFocus
            inputStyle={{
              width: "2.5rem",
              height: "2.5rem",
              margin: "0 0.5rem",
              fontSize: "1.5rem",
              borderRadius: 4,
              border: "1px solid #ccc",
              textAlign: "center",
            }}
            containerStyle="flex justify-center"
          />
        </div>

        {!isValid && <Error message="*Please enter a valid 6-digit OTP" />}

        <div className="mt-8">
          <Button
            label={
              isUsermanagementLoader ? (
                <div className="flex justify-center">
                  <svg
                    className="animate-spin h-6 w-6 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              ) : (
                "Verify"
              )
            }
            varient="contained"
            color="primary"
            fullWidth={true}
            onClick={handleSubmit}
            disabled={isUsermanagementLoader}
          />
        </div>

        <div className="mt-3 text-center">
          <p className="text-sm text-gray-600 font-medium mt-2 ">
            {timer > 0
              ? `You can resend the code in ${timer} second${timer !== 1 ? "s" : ""}.`
              : "You can now resend the code."}
          </p>
        </div>

        <div className="mt-5">
          <p className="text-base font-medium text-center mt-5 ">
            Didn't receive a code?{" "}
            <span
              className={`cursor-pointer ${timer > 0 ? "text-gray-400" : "text-primary hover:underline"}`}
              onClick={timer === 0 ? handleResend : null}
            >
              Resend code
            </span>
          </p>
        </div>


        <Backbutton />
      </div>
    </div>
  );
};

export default Verification;
